import type { ReactNode } from 'react';

/** Centered, max-width card shell used by the auth/status screens. */
export function CenteredScreen({
  children,
  title,
  subtitle,
  logo,
}: {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  /** Optional brand logo shown above the title (e.g. on the login screen). */
  logo?: string;
}): JSX.Element {
  return (
    <div className="flex min-h-full flex-1 items-center justify-center p-5">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-100">
        {logo ? (
          <img src={logo} alt="ANYWAY IT SOLUTIONS" className="mx-auto mb-5 w-full max-w-[190px]" />
        ) : null}
        {title ? <h1 className="text-xl font-bold text-slate-900">{title}</h1> : null}
        {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
        <div className={title ? 'mt-5' : ''}>{children}</div>
      </div>
    </div>
  );
}
